import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as r } from "../constants.js";
const t = ({ baseUrl: t2, baseQuery: n }) => {
  const o = e({ reducerPath: "meteringNodeKindApi", baseQuery: n({ baseUrl: `${t2}/metering-node-kinds` }), keepUnusedDataFor: r, endpoints: (e2) => ({ getMeteringNodeKind: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetMeteringNodeKindQuery: d } = o;
  return { meteringNodeKindApi: o, useGetMeteringNodeKindQuery: d };
};
export {
  t as initializeMeteringNodeKindApi
};
//# sourceMappingURL=meteringNodeKindApi.js.map
